import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Switch, Route, useLocation, useRouteMatch } from 'react-router-dom';

import ViewTitle from '../../common/view-title';
import Loader from '../../common/loader';
import NotFound from '../../common/not-found';

import ProcessV2Menu from './process-v2-menu';
import ProcessV2Index from './process-v2-index';
import ProcessV2Detail from './process-v2-detail';
import ProcessV2Pending from './process-v2-pending';

import helpers from '../../utils/helpers';

const useStyles = makeStyles(() => ({
    root: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
    }
}));

const ProcessV2 = () => {

    const classes = useStyles();
    const { pathname } = useLocation();
    const { path } = useRouteMatch();
    const [state, setState] = useState({
        loading: true,
        permissions: {}
    });

    useEffect(() => {
        const validatePermissions = () => {
            const permissions = helpers.getPermissions(pathname);
            setState(prev => ({ ...prev, permissions, loading: false }));
        }

        validatePermissions();
    }, []);

    if (state.loading) return <Loader />;

    if (!state.permissions?.read_attr) return <NotFound />;

    return (
        <div className={classes.root}>
            <ViewTitle sedeFlag title='Ticket processes v2' />

            <Switch>
                <Route exact path={path}><ProcessV2Menu permissions={state.permissions} /></Route>
                <Route exact path={`${path}/pending`}><ProcessV2Pending permissions={state.permissions} /></Route>
                <Route exact path={`${path}/detail`}><ProcessV2Detail permissions={state.permissions} /></Route>
                <Route exact path={`${path}/index`}><ProcessV2Index permissions={state.permissions} /></Route>
                <Route path={`${path}/*`}><NotFound /></Route>
            </Switch>
        </div>
    );
}

export default ProcessV2;